export default "__VITE_ASSET__DCsVTdPe__"